export enum TraderootAccountStatus {}

export enum TraderootAccountStatusText {
  Active = 'Active',
  Inactive = 'Inactive',
  New = 'New',
  Closed = 'Closed',
  Frozen = 'Frozen',
  NotAvailable = 'NotAvailable',
  AwaitingDeposit = 'AwaitingDeposit',
  UnderInvestigation = 'UnderInvestigation',
  Dormant = 'Dormant',
  Deleted = 'Deleted',
}

export enum TraderootAccountActionType {
  Block = 'block',
  Unblock = 'unblock',
}
